<section class="contact">
  <div class="bg-form">
    <div class="container">
      <h2 class="text-center">Информация</h2>
      <p class="text-center"></p>
      <div class="animatedParent">
        <div class="row">
          <div class="animated bounceInLeft">
            <div class="animatedParent">
              <div class="container">
                <div class="info-plan">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12 animated bounceInLeft">
                        <div class="text-center">
                          <img src="assets/images/check.svg" alt="improving">
                        </div>




                        <p class="pb-2 mb-2">Постановление Правительства РФ от 31 декабря 2021 г. № 2607 <br>
                          “Об утверждении Правил оказания телематических услуг связи”
                          <a class="btn-link" target="_blank" href="/assets/file/№2607.pdf">Скачать Постановление Правительства РФ от 31 декабря 2021</a></p>

                      </div>
                    </div>
                  </div>
                </div>
              </div><!--container-->
            </div>
          </div>
        </div>
      </div><!--info-block-contact-->
    </div>
  </div>
</section>

